import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import Header from '../../components/Header';
import { tokens } from '../../theme';
import AdStatisticsTable from '../../components/ad-statistics/AdStatisticsTable';

const AdStatistics: FC = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px">
      <Header
        title="Ad Statistiken"
        subtitle="Performance evaluation of newsletter advertisements grouped by individual ads"
      />
      <Box
        display="grid"
        gridTemplateColumns="1fr"
        gap="20px"
        sx={{
          backgroundColor: colors.primary[400],
          padding: '20px',
          borderRadius: '8px',
        }}
      >
        <AdStatisticsTable />
      </Box>
    </Box>
  );
};

export default AdStatistics;
